import makeStyles from '@mui/styles/makeStyles';
import React, { useState, useRef } from 'react';
import Form, { convertObjToJbuilder, convertJBuilderToObj } from 'global/components/form';
import { get, flatten, set, unset, size, last } from 'global/lib/lodash';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { Text } from 'global/components/text';
import { Button } from '../../../global/components/Button';
import { Row } from '../../../global/components/row';
import { Icon } from '@mui/material';
import SnackAlerts from 'global/components/snack-alerts';
import { cleanCopy, guid, letterFromAlphabet, makeArray, stringObj } from '../../../global/utils';
import { sendData } from 'redux/actions/sendData';
import { awaitAll } from '../../../global/utils/awaitAll';
import { sortItemsAlphabetically } from 'global/utils';
import { isObject, sortBy } from '../../../global/lib/lodash';

const defaults = {
  name: '',
  description: '',
  isDirty: false,
};

const defaultScore = {
  0: '',
  100: '',
};

const gpadefaultScore = {
  0: '',
  25: '',
  50: '',
  75: '',
  100: '',
};

// const opts = [{ id: '0' }, { id: '100' }];

// const gpaopts = [{ id: '0' }, { id: '25' }, { id: '50' }, { id: '75' }, { id: '100' }];

const allopts = makeArray(101).map((a, i) => ({ id: i.toString() }));

export const CreateChecklist = (props) => {
  const { doc } = props;
  const classes = useStyles();
  const editVals = get(doc, 'editionDocuments.0.document.editMode', {});
  const { owned, unique, unscored } = editVals;
  const formRef = useRef();

  const [state, setState] = useState({
    isEdit: !!props.checklist, // false,
    checkpoints: !!props.checklist ? get(props, 'checklist.checkpoints', []) : [guid()],
    update: 0,
  });

  const [formState, _setFormState] = useState({});
  let [dFormState, _setDFormState] = useState({});
  const [alerts, setAlerts] = useState();

  const dref = useRef();
  const drefprev = useRef();
  const cpref = useRef();

  const setFormState = fs => {
    _setFormState(fs);
    setState(s => ({ ...s, update: s.update + 1 }));
  }

  const supersets = useRetrieveData(
    { url: '/systems' },
    {
      build: ['systems'],
      transformData: (d) => {
        return d.map((item) => ({ ...item, value: item.id, title: item.name }));
      },
    }
  );

  const classifications = useRetrieveData(
    { url: '/classifications' },
    {
      build: ['classifications'],
      transformData: (d) => {
        return d.map((item) => ({ ...item, value: item.id, title: item.name }));
      },
    }
  );

  const setDFormState = (fs) => {
    const cur = dFormState.toggle2;
    dFormState = fs;
    _setDFormState({ ...dFormState });

    const currentcref = get(cpref, 'current', {});

    if (fs.toggle2 != cur && !!cur) {
      dref.current.updateState('toggle2', fs.toggle2, true, false);
      dref.current.updateState('options', convertObjToJbuilder(fs.toggle2 === 1 ? cleanCopy(defaultScore) : cleanCopy(gpadefaultScore)), true, false);

      Object.keys(currentcref).map((k) => {
        const { comp } = currentcref[k];
        comp && comp.updateState && comp.updateState('options', convertObjToJbuilder(fs.toggle2 === 1 ? cleanCopy(defaultScore) : cleanCopy(gpadefaultScore)), true, false);
      });
    }

    const copy = cleanCopy(dFormState.options);
    Object.keys(currentcref).map((k) => {
      const { comp } = currentcref[k];
      const crefoptions = get(comp, 'formState.options', []);

      copy.map((co, i) => {
        const crefind = crefoptions.findIndex((o) => o.property == co.property);
        const crefval = get(crefoptions, `${crefind}.value`);
        const prevValue = get(
          get(drefprev, 'current.options', []).find((o) => o.property == co.property),
          'value'
        );

        if (crefind == -1) {
          set(crefoptions, i, co);
        } else if (!crefval || crefval == prevValue) {
          set(crefoptions, `${crefind}.value`, co.value);
        }
      });

      comp && comp.updateState && comp.updateState('options', cleanCopy(crefoptions), true, false);
    });

    set(drefprev, 'current', cleanCopy(fs));
  };

  const setCpFormState = (cp, fs) => {
    const cpid = isObject(cp) ? `_${cp.id}` : cp;
    const cps = get(cpref, 'current', {});
    set(cps, cpid, fs);
    set(cpref, 'current', cps);
    setState((s) => ({ ...s, update: s.update + 1 }));
  };

  // Monitor which checkpoints have changed
  const cprefUpdated = Object.keys(get(cpref,'current',[])).reduce((agg,key) => {
    const cProps = get(cpref,`current.${key}.checkpoint`,[]);
    const oProps = get(cpref,`current.${key}.options`,[]);
    const originalOptions = get(get(state,'checkpoints',[]).find((i) => key.includes(get(i,'id'))),'checkpointOptions',[]);
    // Check to see if an option was deleted or added
    if (size(oProps) !== (size(originalOptions) || 0)) set(agg,key,get(cpref,`current.${key}`));
    // OR if anything has been changed (isDirty)
    cProps.concat(oProps).forEach((val) => {
      if (get(val,'isDirty')) set(agg,key,get(cpref,`current.${key}`));
    });
    return agg;
  },{});

  // Keep a list of deleted checkpoints
  const cprefToDelete = get(props, 'checklist.checkpoints', []).reduce((agg,cp) => {
    if (isObject(cp) && !state.checkpoints.find((c) => c.id == cp.id)) {
      agg.push(cp);
    }
    return agg;
  },[]);

  const submit = async () => {
    try {
      const { isEdit } = state;
      const cl = { ...formState };

      const isComplex = get(cl, 'toggle', 1) == 2;
      const rows = get(cl, 'checkdescriptions', '')
        .split('\n')
        .filter((f) => !!f);

      const tradeTypes = get(cl, 'tradeTypes', []);
      unset(cl, 'system');
      unset(cl, 'toggle');
      unset(cl, 'checkdescriptions');
      unset(cl, 'tradeTypes');

      let clid = get(props, 'checklist.id');
      const edition_id = get(doc, 'id');
      const edition_document_id = get(
        get(doc, 'editionDocuments', []).find((ed) => ed.documentableId == clid),
        'id'
      );

      if (clid) {
        set(cl, 'edition_id', edition_id);
        set(cl, 'edition_document_id', edition_document_id);
      }

      if (props.update_non_unique) {
        set(cl, 'update_non_unique', 1);
      }

      // Check to see what in the Checklist has been changed
      const checklistKeys = ['classification_id','description','name'];
      const checklistUpdated = checklistKeys.reduce((agg,key) => {
        const camelCaseKey = key.toLowerCase().replace(/([-_][a-z])/g, group =>
          group
            .toUpperCase()
            .replace('-', '')
            .replace('_', '')
        );
        if (get(cl,key) !== get(props,`checklist.${camelCaseKey}`) && 
            parseInt(get(cl,key)) !== get(props,`checklist.${camelCaseKey}`)) {
            agg.push(key);
        }
        return agg;
      },[]);

      // Logic: If the checklist info has been changed -- update
      //   If not, then don't update if there's also no checkpoint updates (nothing has changed)
      //   If only checkpoints have changed, we check to see if the checklist is !unscored, !owned, or
      //     if the user selected to create new revision (!update_non_unique and !unique), in which cases
      //     we need to patch the checklist prior to other updates. Otherwise, we leave the checklist alone.
      //   In many cases, checkpoints can get edited/changed without touching the checklist.
      const shouldUpdateChecklist = size(checklistUpdated) > 0 || size(tradeTypes) ||
        ((size(cprefUpdated) > 0 || size(cprefToDelete > 0)) &&
          !!editVals && (!unscored || !owned || (!unique && !props.update_non_unique)));

      if (!isEdit || shouldUpdateChecklist) {
        const createdchecklist = await sendData(
          {
            url: `/checklists${clid ? `/${clid}` : ''}`,
            method: isEdit ? 'patch' : 'post',
            data: {
              data: {
                id: clid,
                type: 'checklists',
                attributes: stringObj(cl),
                relationships: {
                  tradeTypes: {
                    data: (tradeTypes || []).map((t, i) => ({ type: 'trade-types', id: t.id, pivot: { order: `${i}` } }))
                  }
                }
              },
            },
          },
          {
            normalize: { build: ['checklists'] },
          }
        );

        clid = get(createdchecklist, '0.id', '').toString();
      }
      const cps = [];

      if (isComplex) {
        state.checkpoints.map((cp) => {
          const isNew = !isObject(cp);
          const cpid = isNew ? cp : `_${cp.id}`;
          const vals = get(cpref, `current.${cpid}`, {});
          // Check to see if this particular checkpoint has changed; if not, skip
          if (get(cprefUpdated,cpid)) {

            const checkpoint = convertJBuilderToObj(vals.checkpoint);
            const options = convertJBuilderToObj(vals.options);

            cps.push({
              data: {
                data: {
                  id: isNew ? undefined : cp.id.toString(),
                  type: 'checkpoints',
                  attributes: stringObj({
                    name: get(checkpoint, 'name', ''),
                    description: get(checkpoint, 'description', ''),
                    notes: get(checkpoint, 'notes', ''),
                    // If `update_non_unique` is set, this needs to be included with checkpoint updates also
                    ...(props.update_non_unique ? {update_non_unique: 1} : {}),
                    ...(isNew ? {} : { edition_id, edition_document_id }),
                  }),
                  relationships: {
                    checklists: {
                      data: [{ type: 'checklists', id: clid }],
                    },
                  },
                },
              },
              onSuccess: async (created) => {
                //delete removed ones
                await Promise.all(
                  get(last(created), 'checkpointOptions', []).map(async (f) => {
                    const isDel = !(f.value in options);
                    if (isDel && f.id) {
                      await sendData({
                        url: `/checkpoint-options/${f.id}`,
                        method: 'delete',
                        data: {
                          data: {
                            type: 'checkpoint-options',
                            id: f.id,
                          },
                        },
                      });
                    }
                  })
                );

                await Promise.all(
                  Object.keys(options).map(async (k) => {
                    const cpo = !isNew ? get(last(created), 'checkpointOptions', []).find((o) => o.value == k) : undefined;

                    const meth = {
                      url: !!cpo ? `/checkpoint-options/${cpo.id}` : `/checkpoint-options`,
                      method: !!cpo ? 'patch' : 'post',
                    };

                    await sendData({
                      ...meth,
                      data: {
                        data: {
                          id: !!cpo ? cpo.id : undefined,
                          type: 'checkpoint-options',
                          attributes: stringObj({
                            checkpoint_id: get(last(created), 'id'),
                            name: options[k],
                            value: k,
                          }),
                        },
                      },
                    });
                  })
                );
              },
            });
          }
        });
      } else {
        rows.map((r, i) => {
          cps.push({
            data: {
              data: {
                type: 'checkpoints',
                attributes: {
                  name: letterFromAlphabet(i),
                  description: r,
                },
                relationships: {
                  checklists: {
                    data: [{ type: 'checklists', id: clid }],
                  },
                },
              },
            },
            onSuccess: async (created) => {
              const simpleopts = [
                { name: '', value: 0 },
                { name: '', value: 100 },
              ];

              await Promise.all(
                simpleopts.map(async (opt) => {
                  await sendData({
                    url: `/checkpoint-options`,
                    method: 'post',
                    data: {
                      data: {
                        type: 'checkpoint-options',
                        attributes: stringObj({
                          checkpoint_id: get(last(created), 'id'),
                          name: opt.name,
                          value: opt.value,
                        }),
                      },
                    },
                  });
                })
              );
            },
          });
        });
      }

      // Delete any removed checkpoints
      if (state.isEdit) {
        await Promise.all(
          cprefToDelete.map(async (cp) => {
            await sendData({
              url: `/checkpoints/${cp.id}`,
              method: 'patch',
              data: {
                data: {
                  type: 'checkpoints',
                  id: cp.id,
                  attributes: {
                    archived: true,
                    edition_document_id,
                    edition_id
                  }
                },
              },
            });
          })
        );
      }

      // Create and modify checkpoints (previously defined as modified)
      await awaitAll(
        cps.map((cp) => () => async () => {
          const hasId = get(cp, 'data.data.id');

          const result = await sendData(
            {
              url: `/checkpoints${hasId ? `/${hasId}` : ''}`,
              method: !hasId ? 'post' : 'patch',
              data: cp.data,
            },
            { normalize: { build: ['checkpoints'] } }
          );

          if (cp.onSuccess) {
            await cp.onSuccess(result);
          }
        })
      );

      const classid = get(cl, 'classification_id');
      const amt = size(get(doc, 'documents', []).filter((f) => f.classificationId == classid));

      // Create Edition-Document if creating brand-new checklist
      if (!state.isEdit) {
        await sendData({
          url: `/edition-documents`,
          method: 'post',
          data: {
            data: {
              type: 'edition-documents',
              attributes: stringObj({
                edition_id,
                documentable_id: clid,
                documentable_type: 'checklist',
                classification_id: classid,
                order: amt,
                primary_document: !amt ? 1 : 0,
              }),
            },
          },
        });
      }

      props.onClose && props.onClose(true);
    } catch (err) {
      setAlerts({ message: err.message, severity: 'error' });
    }
  };

  const addCheckpoint = () => {
    const id = guid();
    setState((s) => ({ ...s, checkpoints: [...s.checkpoints, id] }));
  };

  const removeCheckpoint = (cp) => {
    const checkpoints = state.checkpoints.filter((c) => c !== cp);
    setState((s) => ({ ...s, checkpoints: !size(checkpoints) ? [guid()] : checkpoints }));
    unset(cpref, `current.${cp}`);
  };

  const getValidCheckpointOpts = (obj = {}) => {
    const ret = {
      id: obj.id,
      name: obj.name,
      description: obj.description,
      notes: obj.notes,
    };

    Object.keys(ret).map((k) => {
      const val = get(ret, k);

      if (!val) {
        unset(ret, k);
      }
    });

    return ret;
  };

  const cposToObj = (cpos = []) => {
    const obj = {};
    cpos.map((cpo) => {
      obj[cpo.value] = cpo.name;
    });
    return convertObjToJbuilder(obj);
  };

  const data = props.checklist || {};

  const allCheckpointsValid = () => {
    const cps = flatten(
      state.checkpoints.map((_id) => {
        const id = isObject(_id) ? `_${_id.id}` : _id;
        const obj = get(cpref, `current.${id}.comp.formState`, get(cpref, `current.${id}`), {});

        return [...(get(obj, 'checkpoint', []) || []), ...(get(obj, 'options', []) || [])];
      })
    ).filter((cp) => get(cp, 'property') !== 'id');

    const valid = cps.filter((cp) => cp.valid);

    return size(valid) >= size(cps);
  };

  const onSystemChange = (e) => {
    const val = e.target.value;
    const system = supersets.data.find(s => s.id == val.system);
    const classy = classifications.data.find(f => f.id == formState.classification_id);

    Object.keys(formState).forEach((key) => {
      if (key === 'system') {
        formRef.current.updateState(key, val);
      } else {
        formRef.current.updateState(key, formState[key]);
      }
    });

    if (!classy || !system || get(classy, 'system.id') != get(system, 'id')) {
      formRef.current.updateState('classification_id', null);
    }
  }

  const createDisabled = (() => {
    const classid = parseInt(get(formState, 'classification_id', 0));
    const classvalid = !isNaN(classid) && !!classid;

    return !get(formState, 'name') || !classvalid || (get(formState, 'toggle', 1) == 1 ? !get(formState, 'checkdescriptions') : !allCheckpointsValid())
  })();

  return (
    <div>
      <Form
        showAllScreens
        formLoading={state.formLoading}
        onFormState={setFormState}
        formStyle={classes.formStyle}
        ref={formRef}
        screens={[
          {
            inputs: [
              {
                id: 'name',
                type: 'TextField',
                defaultValue: () => get(data, 'name', ''),
                props: {
                  label: 'Title',
                },
              },
              {
                id: 'description',
                type: 'TextField',
                defaultValue: () => get(data, 'description', ''),
                props: {
                  label: 'Description',
                  rows: 6,
                  multiline: true,
                },
              },
              {
                id: 'system',
                type: 'Select',
                data: () => supersets.data,
                defaultValue: () => parseInt(get(data, 'classification.system.id', get(data, 'system.id', 0))),
                props: {
                  label: 'System',
                  placeholder: 'Choose a System',
                  onChange: onSystemChange,
                },
              },
              {
                id: 'classification_id',
                type: 'Select',
                data: () => sortItemsAlphabetically(classifications.data.filter((f) => get(f, 'system.id') == get(formState, 'system'))),
                defaultValue: () => get(data, 'classificationId', 0).toString(),
                props: {
                  label: 'Classification',
                  placeholder: 'Choose Classification',
                  disabled: !get(formState, 'system'),
                  helperText: 'Why do we require a classification? This is the standardized data-point that organizes content together and allows the site to collate data more effectively.',
                },
              },
              {
                id: 'tradeTypes',
                type: 'TradeSelect',
                defaultValue: () => sortBy(get(data, 'tradeTypes', []), 'order'),
                props: {
                  label: 'Trade Type',
                  placeholder: 'Click to Add',
                  disabled: !get(formState, 'system'),
                  sortable: true,
                  helperText: 'Trade Types are used to pre-populate the value assigned in tasks. The first item in the list will be considered the "Default" trade-type',
                },
              },
              {
                id: 'toggle',
                type: 'ToggleButton',
                options: [
                  { title: 'SIMPLE', value: 1 },
                  { title: 'COMPLEX', value: 2 },
                ],
                center: true,
                defaultValue: () => get(formState, 'toggle', state.isEdit ? 2 : 1),
                props: {
                  label: 'Method',
                  exclusive: true,
                  disabled: state.isEdit,
                },
              },
              ...(get(formState, 'toggle', 1) == 1
                ? [
                    {
                      id: 'checkdescriptions',
                      type: 'TextField',
                      defaultValue: () => get(data, 'checkdescriptions', ''),
                      props: {
                        label: '',
                        rows: 8,
                        multiline: true,
                        placeholder: 'Add checkpoint descriptions separated by line',
                      },
                    },
                  ]
                : [
                    !state.isEdit && {
                      id: 'defaults',
                      component: () => (
                        <div style={{ backgroundColor: 'rgba(0,0,0,0.1)', padding: 8 }}>
                          <Text>Default Checkpoint Options</Text>
                          <Form
                            showAllScreens
                            onFormState={setDFormState}
                            ref={dref}
                            screens={[
                              {
                                inputs: [
                                  {
                                    id: 'toggle2',
                                    type: 'ToggleButton',
                                    defaultValue: () => get(dFormState, 'toggle2', 1),
                                    options: [
                                      { title: '0-100% (Pass/Fail)', value: 1 },
                                      { title: '0-4 (GPA)', value: 2 },
                                    ],
                                    props: {
                                      label: 'Presets',
                                      exclusive: true,
                                    },
                                  },
                                  {
                                    id: 'options',
                                    type: 'JsonBuilder',
                                    defaultValue: () => convertObjToJbuilder(defaultScore),
                                    addBtn: {
                                      title: 'ADD OPTION',
                                    },
                                    options: allopts.map((o) => ({
                                      ...o,
                                      label: `${o.id}%`,
                                      props: {
                                        placeholder: 'None',
                                        blankAllowed: true,
                                      },
                                    })),
                                    props: {
                                      label: 'Checkpoint Options',
                                    },
                                  },
                                ],
                              },
                            ]}
                          />
                        </div>
                      ),
                    },
                    ...state.checkpoints.map((cp, i) => {
                      const cpid = isObject(cp) ? `_${cp.id}` : cp;
                      return {
                        id: `checkpoints_${cpid}`,
                        add: i === state.checkpoints.length - 1,
                        addBtn: {
                          title: 'ADD CHECKPOINT',
                        },
                        deleteBtn: {
                          title: 'REMOVE CHECKPOINT',
                        },
                        inputStyle: classes.checkContainer,
                        remove: size(state.checkpoints) > 1,
                        onAdd: addCheckpoint,
                        onRemove: () => {
                          removeCheckpoint(cp);
                        },
                        component: (
                          <div>
                            <Form
                              showAllScreens
                              onFormState={(fs) => setCpFormState(cp, fs)}
                              ref={(r) => set(cpref, `current.${cpid}.comp`, r)}
                              screens={[
                                {
                                  inputs: [
                                    {
                                      id: 'checkpoint',
                                      type: 'JsonBuilder',
                                      defaultValue: () => convertObjToJbuilder(isObject(cp) ? getValidCheckpointOpts(cp) : defaults),
                                      addBtn: {
                                        title: 'ADD OPTION',
                                      },
                                      options: [
                                        {
                                          id: 'id',
                                          canDelete: false,
                                          show: false,
                                        },
                                        {
                                          id: 'name',
                                          label: 'Title',
                                          canDelete: false,
                                          props: {
                                            placeholder: 'None',
                                          },
                                        },
                                        {
                                          id: 'description',
                                          label: 'Description',
                                          props: {
                                            placeholder: 'None',
                                            blankAllowed: true,
                                          },
                                        },
                                        {
                                          id: 'notes',
                                          label: 'Notes',
                                          props: {
                                            placeholder: 'None',
                                          },
                                        },
                                      ],
                                      props: {
                                        label: 'Checkpoint',
                                      },
                                    },
                                    {
                                      id: 'options',
                                      type: 'JsonBuilder',
                                      style: { paddingLeft: '10%', width: '90%' },
                                      addBtn: {
                                        title: 'ADD OPTION',
                                      },
                                      defaultValue: () => (isObject(cp) ? cposToObj(get(cp, 'checkpointOptions', [])) : cleanCopy(dFormState.options || [])),
                                      options: allopts.map((o) => ({
                                        ...o,
                                        label: `${o.id}%`,
                                        props: {
                                          placeholder: 'None',
                                          blankAllowed: true,
                                        },
                                      })),
                                      props: {
                                        label: 'Checkpoint Options',
                                      },
                                    },
                                  ],
                                },
                              ]}
                            />
                          </div>
                        ),
                      };
                    }),
                  ].filter((f) => !!f)),
            ],
          },
        ]}
      />
      <Row fullWidth center>
        <Button disabled={createDisabled} onClick={submit} startIcon={<Icon>save</Icon>}>
          {state.isEdit ? 'UPDATE' : 'CREATE'}
        </Button>
      </Row>
      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  formStyle: {
    overflow: 'visible',
  },
  checkContainer: {
    boxShadow: '0 0 8px rgba(0,0,0,0.4)',
    marginBottom: 16,
    boxSizing: 'border-box',
    padding: 8,
  },
}));
